const success = action => {
  return `${action}_SUCCESS`;
};

const error = action => {
  return `${action}_ERROR`;
};

export { error, success };
